<template>
    <div>
        <div class="wrapper">
            <div class="login-content">
                <div class="login-title">
                    欢迎使用囊中对比
                </div>
                <div class="login-desc">
                    {{ alertMsg }}
                </div>
                <div class="login-code">
                    <img v-if="status === '0'" :src="codeImg" alt="">
                    <img v-else-if="status == null || status === '-1' || status === '-2'" @click="refreshCode"
                        src="@/assets/images/refresh-code.png" alt="">
                    <img v-else-if="status === '1' || status === '2'" src="@/assets/images/scan-code.png" alt="">
                    <img class="scan" src="@/assets/images/scan.png" alt="">
                </div>
                <div class="login-alert ">
                    切换至<a href="javascript:;" @click="accountLogin">账号登录 ></a>
                </div>
                <div class="login-aggrement">
                    登录/注册表示同意
                    <a href="javascript:;" @click="openPrivacyPolicy">隐私政策</a>
                    和
                    <a href="javascript:;" @click="openServiceAgreement">服务条款</a>
                </div>
            </div>
        </div>
        
        <!-- 添加隐私政策弹窗 -->
        <div v-if="showPrivacyPolicy" class="policy-modal">
          <div class="modal-content">
            <iframe :src="privacyPolicyUrl" frameborder="0"></iframe>
            <button @click="closePrivacyPolicy" class="close-btn">返回</button>
          </div>
        </div>

        <!-- 服务条款弹窗 -->
        <div v-if="showServiceAgreement" class="policy-modal">
          <div class="modal-content">
            <iframe :src="serviceAgreementUrl" frameborder="0"></iframe>
            <button @click="closeServiceAgreement" class="close-btn">返回</button>
          </div>
        </div>
    </div>
</template>

<script>
import { getMiniLoginQrCode, getScanCodeStatus } from "@/api/index";
import { setToken } from '@/utils/auth'
export default {
    name: "CodeLoginPage",
    data() {
        return {
            alertMsg: "打开微信扫一扫，快速登录/注册",
            scene: null,
            codeImg: null,
            status: null,
            pollTimer: null,
            qrGeneration: 0,
            showPrivacyPolicy: false,
            showServiceAgreement: false,
            privacyPolicyUrl: 'https://help.srnz.net/service/privicy.html',
            serviceAgreementUrl: 'https://help.srnz.net/service/agreement.html'
        }
    },
    mounted() {
        this.createQrCode();
    },
    destroyed() {
        this.stopPolling();
    },
    methods: {
        accountLogin() {
            this.stopPolling();
            this.$router.push("/login/account");
        },
        // 创建小程序码
        async createQrCode() {
            this.stopPolling();
            const generation = ++this.qrGeneration;
            this.scene = null;
            this.codeImg = null;
            this.status = null;
            this.alertMsg = "正在生成登录二维码...";
            try {
                const response = await getMiniLoginQrCode();
                if (generation !== this.qrGeneration) return;
                if (!response.data || !response.data.scene || !response.data.image) {
                    throw new Error("二维码响应数据不完整");
                }
                this.scene = response.data.scene;
                this.codeImg = response.data.image;
                this.status = '0';
                this.alertMsg = "打开微信扫一扫，快速登录/注册";
                this.startPolling(this.scene);
            } catch (error) {
                if (generation !== this.qrGeneration) return;
                this.status = '-1';
                this.alertMsg = "二维码生成失败，请点击刷新";
                console.error('生成登录二维码失败:', error);
            }
        },
        // 获取小程序码状态
        startPolling(scene) {
            this.stopPolling();
            const poll = async () => {
                if (!scene || scene !== this.scene) return;
                try {
                    const response = await getScanCodeStatus({ scene });
                    if (scene !== this.scene || !response.data) return;
                    this.status = response.data.status;
                    let userNumber = response.data.userNumber;
                    let isBind = response.data.isBind;
                    let token = response.data.token;
                    if (this.status === '1') {
                        this.alertMsg = "已完成扫描，请确认操作";
                    } else if (this.status === '2') {
                        if (!token) {
                            this.alertMsg = "登录凭证生成失败，请刷新二维码重试";
                            this.stopPolling();
                            return;
                        }
                        this.alertMsg = "已确认登录";
                        this.stopPolling();
                        this.$store.commit("user/SET_TOKEN", token);
                        setToken(token);
                        if(isBind === '0'){
                            this.$router.push({path:"/login/bind",query: {
                                userNumber: userNumber,
                             }});
                        } else {
                            this.$router.push("/community/home");
                        }
                        return;
                    } else if (this.status === '-1') {
                        this.alertMsg = "二维码已过期，请刷新";
                        this.stopPolling();
                        return;
                    } else if (this.status === '-2') {
                        this.alertMsg = "已取消登录";
                        this.stopPolling();
                        return;
                    }
                } catch (error) {
                    console.warn('查询扫码状态失败:', error);
                }
                if (scene === this.scene) {
                    this.pollTimer = setTimeout(poll, 1500);
                }
            };
            this.pollTimer = setTimeout(poll, 1000);
        },
        stopPolling() {
            if (this.pollTimer) {
                clearTimeout(this.pollTimer);
                this.pollTimer = null;
            }
        },

        refreshCode() {
            this.createQrCode();
        },
        openPrivacyPolicy() {
          this.showPrivacyPolicy = true;
        },
        closePrivacyPolicy() {
          this.showPrivacyPolicy = false;
        },
        openServiceAgreement() {
          this.showServiceAgreement = true;
        },
        closeServiceAgreement() {
          this.showServiceAgreement = false;
        }
    }
}


</script>
<style lang="scss" scoped>
.wrapper {

    background-image: url(~@/assets/images/login-bgc.svg);
    background-size: 100%;
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;

    .login-content {
        border-radius: 10px;
        padding: 60px;
        background-color: $background-color;
        display: flex;
        align-items: center;
        flex-direction: column;
        box-shadow: 0px 0px 5px 0px rgba(129, 129, 129, 0.25);
        // align-items : center;
        .login-title {
            font-size: $font-size-Level4;
        }

        .login-desc {
            margin-top: 32px;
            font-size: $font-size-primary;
            color: $font-color-primary;
        }

        .login-code {
            margin-top: 32px;
            position: relative;
            img {
                width: 170px;
                height: 170px;
                cursor: pointer;

            }

            .scan {
                position: absolute;
                left: 0;
                top: 0;
            }
        }

        .login-alert {
            margin-top: 24px;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            a {
                color: $font-color-third;
            }
            font-size: $font-size-primary;
        }

        .login-aggrement {
            margin-top: 66px;

            a {
                color: $font-color-third;
            }
        }
    }
}

.policy-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  z-index: 1000;

  .modal-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;

    iframe {
      flex-grow: 1;
      width: 100%;
      height: calc(100% - 50px);
      border: none;
    }

    .close-btn {
      height: 50px;
      width: 100%;
      background-color: $color-primary;
      color: white;
      border: none;
      font-size: 16px;
      cursor: pointer;

      &:hover {
        background-color: darken($color-primary, 5%);
      }
    }
  }
}
</style>
